jQuery( document ).ready(function( $ ) {

    $( window ).on( 'elementor/frontend/init', function () {
        // wait for elementor pro to load
        elementorFrontend.on( 'components:init', function () {
        
            const swiperElement = $( '.dApps-carousel' ).parents('.elementor-widget-image-carousel');
            const swiperConfig = swiperElement.data( 'settings' );
            const asyncSwiper = elementorFrontend.utils.swiper;

            // Reinitialize swiper just to get its instance since old method is not working anymore
            new asyncSwiper( swiperElement, swiperConfig ).then( ( newSwiperInstance ) => {
                // For some reason promise returned instance cannot be overridden
                // so we still fetch it the old way
                const swiperInstance = $( '.dApps-carousel' ).data('swiper');

                // Check screen width
                var screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

                // Check if portrait mode
                let isPortrait = window.innerHeight > window.innerWidth ? true : false;

                // Check if portrait on small screen
                let isPortraitMobile = false;
                if ( screenWidth < 768 && isPortrait ) {
                    isPortraitMobile = true;
                }

                // This will set the offset of slides
                // so that the next and previous slide will looks cut in half
                if ( !isPortraitMobile ) {
                    const slideHalfWidth = $('.swiper-slide').width() / 2;
                    swiperInstance.params.slidesOffsetAfter = -slideHalfWidth;
                    swiperInstance.params.slidesOffsetBefore = slideHalfWidth;

                    swiperInstance.update();

                    $('.swiper-pagination').hide();
                } else {
                    $('.swiper-pagination').show();
                }
            } );
        });
    });

});